import {
  ActivityChangeOptions,
  ActivityItem,
  DeltaText,
} from '@spotify/plugin-confidence-activity-react';
import { createWorkflowUpdatesChangeExtension } from '@spotify/plugin-confidence-workflows-react';

import { RolloutData } from '../../types';

const RolloutDescriptionChangeRender = ({ change }: ActivityChangeOptions) => {
  const oldValue = change.oldValue as RolloutData | null;
  const newValue = change.newValue as RolloutData | null;

  return (
    <ActivityItem.Section label="Updated description">
      <DeltaText
        oldText={oldValue?.description ?? ''}
        newText={newValue?.description ?? ''}
      />
    </ActivityItem.Section>
  );
};

export const ROLLOUT_DESCRIPTION_CHANGE_EXTENSION =
  createWorkflowUpdatesChangeExtension({
    id: 'rollout-description-change',
    predicate: ({ change }) => {
      if (change.fieldPath !== '/module_data/rollout') {
        return false;
      }
      const oldValue = change.oldValue as RolloutData | null;
      const newValue = change.newValue as RolloutData | null;
      return oldValue?.description !== newValue?.description;
    },
    render: RolloutDescriptionChangeRender,
  });
